import { Check, Copy, TriangleAlert } from 'lucide-react';
import { useState } from 'react';

import { AtlasIcon } from '@crossnokaye/ux-animatics';

import { SUPPORT_CONTACT_NUMBER } from '@/constants';

export interface ErrorMessageProps {
  errorMessage: string;
  children?: React.ReactNode;
}

export const ErrorMessage = ({ errorMessage, children }: ErrorMessageProps) => {
  const [copied, setCopied] = useState(false);

  const handleCopyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(errorMessage);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // Reset after 2 seconds
    } catch (err) {
      console.error('Failed to copy to clipboard:', err);
    }
  };

  return (
    <div className={'flex flex-col items-center justify-center h-screen text-lg gap-6 px-8'}>
      <div className={'flex flex-col items-center gap-6 max-w-2xl text-center'}>
        <AtlasIcon symbol={'atlasLogoFull'} width={'12rem'} height={'2rem'} />
        <div className={'flex flex-row gap-2 items-start'}>
          <div className={'flex items-center mt-0.5'}>
            <TriangleAlert className="glyph glyph-md text-warning" aria-hidden="true" />
          </div>
          <div>{`Something went wrong. Please reload the page. If the problem persists, please contact support at ${SUPPORT_CONTACT_NUMBER}`}</div>
        </div>
        <div className={'relative group'}>
          <div
            className={
              'text-background text-md bg-tertiary p-3 rounded max-w-full break-words pr-12'
            }
          >{`ERROR: ${errorMessage}`}</div>
          <button
            onClick={handleCopyToClipboard}
            className={
              'absolute right-2 top-1/2 -translate-y-1/2 p-1.5 rounded hover:bg-background/20 transition-colors'
            }
            title={copied ? 'Copied!' : 'Copy error message'}
          >
            {copied ? (
              <Check className="glyph glyph-sm text-primary" aria-hidden="true" />
            ) : (
              <Copy
                className="glyph glyph-sm text-background/70 hover:text-background"
                aria-hidden="true"
              />
            )}
          </button>
        </div>
      </div>
      {children}
    </div>
  );
};
